import { createSelector } from 'reselect'

const getAdminOnboardingData = state => state.adminOnboarding
const getUserDataLoaded = state => state.user.fullDataLoaded

const baseAdminOnboarding = createSelector(
	[getAdminOnboardingData, getUserDataLoaded],
	(adminOnboarding, userDataLoaded) => ({
		step: adminOnboarding.step,
		maxVisitedStep: adminOnboarding.maxVisitedStep,
		transitioning: adminOnboarding.transitioning,
		userDataLoaded: !!userDataLoaded,
		showStepsHeader: !adminOnboarding.showLastStep || !adminOnboarding.isAdmin,
		inviteTeacher: adminOnboarding.inviteTeacher,
	})
)

export default baseAdminOnboarding
